<template>

<core-filter-bar>

	<core-filter-bar-left>

		<core-filter-summary :count="count" noun="result" nestedNoun="nested" :noNestedPlural="true" :maximum="maximum" :nested="nested" :loading="loading" />

	</core-filter-bar-left>

	<core-filter-bar-right>

		<core-filter-sort page="collection" filter="collection/sort" />
		
		<core-filter-panel filter="collection" v-on:expandClick="onExpandClick" />

		<core-filter-layout page="collection" filter="config/collection/layout" />

		<core-filter-tags type="collection" />

		<core-filter-presets type="collection" />

		<com-config v-on:refresh="$emit('refresh')" />

		<core-filter-export type="collection" />
		
	</core-filter-bar-right>

	<com-advanced 
		:is-active="is.expanded"
		v-on:close="is.expanded = false" 
		v-on:reset="onResetFilter" 
	/>

	<app-filter-panel-tags 
		type="collection" 
		v-if="can.tag" 
	/>

</core-filter-bar>

</template>

<script>

import comConfig from './Config'
import comAdvanced from './Advanced'

export default {

	props: ['count', 'loading', 'maximum', 'nested'],

	components: {

		'com-config': comConfig,
		'com-advanced': comAdvanced

	},

	data: function() {

		return {

			is: {
				expanded: false
			}

		}

	},

	computed: {

		can: function() {

			return this.$store.getters['service/select/can']

		},

		filter: function() {

			return this.$store.getters['filter/collection']

		}

	},

	methods: {

		onExpandClick: function() {

			this.is.expanded = !this.is.expanded

		},

		onResetFilter: function() {

			this.$store.commit('filter/collection/reset', {
				layout: this.filter.layout
			})

		}

	}

}

</script>

<style scoped>

.filter-text {
	font-size: 12px;
    display: block;
    color: #fff;
    font-weight: 400;
    padding-bottom: 8px;
}

.filter-search-mobile {
	margin: 4px 7px 0px 7px!important;
	width: calc(100% - 16px)!important;
}

@media only screen and (max-width: 767px) {

	.filter-section-first {
		margin-top: 4px;
		border-top: 1px solid rgba(255, 255, 255, 0.1);
	}

}

</style>
